import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationExtras, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Observable, Subject } from 'rxjs';
import { ICommInterface } from 'src/app/types/comm-interface.js';
import { Livechat1 } from 'src/app/types/livechat1';
import { Livechat2 } from 'src/app/types/livechat2';
import { $b } from '../../../libs/browser_utils.js';
import { livechat, messenger } from '../../../libs/livechat_ref.js';
import { AppdataService } from '../app-data/appdata.service';
import { MessengerService } from '../messenger/messenger.service';

@Injectable({
  providedIn: 'root'
})
export class CommunicationInterfaceService {
  // configUrl = '../../../assets/app-config.json';
  configLoaded = false;
  public appConfig;
  public interactionID: any;
  public command = {};
  public startCommandObj = {};
  public messenger = messenger;
  encryptKey = 'ThisIsTheSecret';
  private livechatRef: ICommInterface;
  intent: string = $b.GetQueryString('intent');
  ucid: string = $b.GetQueryString('ucid');
  sessionId: string;

  private callbacks = new Subject<any>();
  private livechatCallback = new Subject<any>();
  private sessionToken = new Subject<any>();
  private chatBotMsg = new Subject<any>();
  private permissions = new Subject<any>();
  customerMessage = new Subject<any>();
  inQueue = new Subject<any>();
  endOfSession = new Subject<any>();

  callbacksObservable: Observable<any> = this.callbacks.asObservable();
  sessionTokenObservable: Observable<any> = this.sessionToken.asObservable();
  chatBotReceivedMessage: Observable<any> = this.chatBotMsg.asObservable();
  livechatCallbackObservable: Observable<any> = this.livechatCallback.asObservable();
  permissionsObservable: Observable<any> = this.permissions.asObservable();
  customerMessageObservable: Observable<any> = this.customerMessage.asObservable();
  inQueueObservable: Observable<any> = this.inQueue.asObservable();
  endOfSessionObservable: Observable<any> = this.endOfSession.asObservable();
  public availableInputDevices = {
    audio: [],
    video: []
  };

  public audio = new Audio();

  public devicePermissions = {
    audio: false,
    video: false,
    location: false,
    webrtc: false,
    screenshare: false
  };

  constructor(private snackBar: MatSnackBar, private route: Router, public zone: NgZone, appDataService: AppdataService, private messengerService: MessengerService) {
    
    console.log('%c CommunicationInterfaceService', 'color:white; background: blue;');

    // if (Object.keys(this.appConfig).length === 0 && this.appConfig.constructor === Object) {
    //   this.decryptAppConfig();
    // }

    appDataService.appConfigSub.subscribe((config) => {
      if (!config) {
        return;
      }
      this.appConfig = config;
      this.startCommandObj = {
        pIntent: this.appConfig.CommunicationInterface.livechat2.intent,
        pUcid: this.appConfig.CommunicationInterface.livechat2.ucid,
        pChannel: this.appConfig.CommunicationInterface.livechat2.pChannel,
        pChatBotSid: this.appConfig.CommunicationInterface.livechat2.pChatBotSid,
        pUserId: null,
        agentid: null,
        interactionid: null,
        node: null,
        mobile: null
      };
  
      window.addEventListener('message', this.receivedChatbotMsg, false);
  
      if (this.appConfig.CommunicationInterface.livechat2.enabled) {
        this.livechatRef = new Livechat2();
        console.log('%c Messenger Value: ', 'color:white; background: blue;', this.messenger);
      } else {
        this.livechatRef = new Livechat1();
      }
    });
  }

  open = () => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.Open();
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
        if (typeof messenger !== 'undefined') {
          console.log('%c ************* Livechat 2 Session Open *************', 'color:white; background: #00BCD4;');
          this.messenger.SessionStart();
        }
      }
    } catch (error) {
      console.error('%c Communication Interface - Open : ', 'color:white; background: #FF5722;', error);
      this.noInternetConnection();
    }
  };

  start = (custInfo: any, []) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.Start(custInfo, []);
        return true;
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
        const msg = {
          Command: 'start',
          InteractionId: undefined,
          Data: JSON.stringify(this.startCommandObj),
          Intent: 'patientInquiryMaker'
        };
        const startMsg = JSON.stringify(msg);
        this.messenger.SendMessage(startMsg);
        console.log(startMsg);
      }
    } catch (error) {
      console.error('%c Communication Interface - Start : ', 'color:white; background: #FF5722;', error);
    }
  };

  setCaptcha = (elementIdRef: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.setCaptchaImage(elementIdRef);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - setCaptcha : ', 'color:white; background: #FF5722;', error);
    }
  };

  resetCaptcha = (elementIdRef: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.resetCaptchaImage(elementIdRef);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - resetCaptcha : ', 'color:white; background: #FF5722;', error);
    }
  };

  accessToken = () => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.GetAccessToken(
          (token: string) => {
            this.sessionToken.next({ successMsg: token });
          },
          (error: string) => {
            this.sessionToken.next({ errorMsg: error });
          }
        );
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - accessToken : ', 'color:white; background: #FF5722;', error);
    }
  };

  receivedChatbotMsg = (msg?: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.OnMessageReceived = (agent: string, message: string, id: string) => {
          this.callbacks.next({ callbackName: 'MessageReceived', params: { agent, message, id } });
        };
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
        console.log('%c ************* Livechat 2 Session Received Bot Msg *************', 'color:white; background: #00BCD4;');
        this.chatBotMsg.next(msg?.data);
      }
    } catch (error) {
      console.error('%c Communication Interface - receivedChatbotMsg : ', 'color:white; background: #FF5722;', error);
    }
  };

  end = (reason?: string, interactionID?: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.End(reason);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
        if (interactionID === '' || interactionID === undefined) {
          interactionID = $b.GetSessionStorage('livechat2InteractionID');
        }
        const msg = {
          Command: 'end',
          InteractionId: interactionID,
          Data: ''
        };
        const endMsg = JSON.stringify(msg);
        this.messenger.SendMessage(endMsg);
      }
    } catch (error) {
      console.error('%c Communication Interface - End : ', 'color:white; background: #FF5722;', error);
    }
  };

  sendMessage = (msg?: any, command?: any, data?: any, interactionID?: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.SendMessage(msg, null);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
        if (interactionID === '' || interactionID === undefined) {
          interactionID = $b.GetSessionStorage('livechat2InteractionID');
        }
        const msgObj = {
          Command: command,
          InteractionId: interactionID,
          Data: JSON.stringify(data),
          Intent: 'patientInquiryMaker'
        };
        console.log(msgObj);
        const startMsg = JSON.stringify(msgObj);
        this.messenger.SendMessage(startMsg);
      }

      this.logToServer('info', 'CommunicationInterfaceService', `sendMessage: ${msg.length}`);
    } catch (error) {
      console.error('%c Communication Interface - SendMessage : ', 'color:white; background: #FF5722;', error);
    }
  };

  sendAppMessage = (msg: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.SendAppMessage(msg);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - SendAppMessage : ', 'color:white; background: #FF5722;', error);
    }
  };

  checkDeviceSupport = () => {
    try {
      livechat.CheckDeviceSupport().then((x) => {
        delete x.MediaDevices;
        this.devicePermissions.webrtc = x.isWebRTCSupported;
        this.devicePermissions.screenshare = x.isScreenshareSupported;
        $b.SetLocalStorage('deviceSupport', JSON.stringify(x));
      });
    } catch (error) {
      console.error('%c Communication Interface - checkDeviceSupport : ', 'color:white; background: #FF5722;', error);
    }
  };

  getAudioVideoInputs = () => {
    /**
     * based on the configuration 'combinedMediaPermission' 
     * media devices are to be captured 
     */

    if(this.appConfig?.permissionsConfig?.combinedMediaPermission) {
      navigator.mediaDevices.getUserMedia({ audio: true, video: true})
      .then((stream) => {
        livechat.CheckDeviceSupport().then((deviceInfo) => {
          deviceInfo.MediaDevices.forEach((device: any) => {
            if (device.kind === 'audioinput') {
              this.upsert(this.availableInputDevices.audio, device);
            }
            this.permissions.next({proceedText: 'Proceed',type: 'video',status: true});
            if (device.kind === 'videoinput') {
              this.upsert(this.availableInputDevices.video, device);
            }
          });
        });
        stream.getTracks().forEach((track) => {        
          this.devicePermissions.audio = true;     
          this.devicePermissions.video = true;     
          track.stop();
        });       
      })
      .catch((err) => {
        if(err.name === 'NotAllowedError'){
          this.permissions.next({proceedText:'Proceed to Chat',type: 'audio',status: false});
          this.snackBar.open(`Microphone access denied`, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['custom-snackbar']
          });
        }
      });
    } else {
      // checking for microphone availability
      navigator.mediaDevices.getUserMedia({ audio: true})
      .then((stream) => {
        livechat.CheckDeviceSupport().then((deviceInfo) => {
          deviceInfo.MediaDevices.forEach((device: any) => {
            if (device.kind === 'audioinput') {
              this.upsert(this.availableInputDevices.audio, device);
            }
          });
        });
        stream.getTracks().forEach((track) => {        
          this.devicePermissions.audio = true;        
          track.stop();
        });
      })
      .catch((err) => {
        if(err.name === 'NotAllowedError'){
          this.permissions.next({proceedText:'Proceed to Chat',type: 'audio',status: false});
          this.snackBar.open(`Microphone access denied`, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['custom-snackbar']
          });
        }
      });

      // checking for camera availability
      navigator.mediaDevices.getUserMedia({ video: true})
      .then((stream) => {
        livechat.CheckDeviceSupport().then((deviceInfo) => {
          deviceInfo.MediaDevices.forEach((device: any) => {
            this.permissions.next({proceedText: 'Proceed',type: 'video',status: true});
            if (device.kind === 'videoinput') {
              this.upsert(this.availableInputDevices.video, device);
            }
          });
        });
        stream.getTracks().forEach((track) => {
          this.devicePermissions.video = true;        
          track.stop();
        });
      })
      .catch((err) => {
        if(err.name === 'NotAllowedError'){
          this.permissions.next({proceedText: 'Proceed to Chat',type: 'video',status: false});
          setTimeout(() => {
            this.snackBar.open(`Camera access denied`, '', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              panelClass: ['custom-snackbar']
            });
          }, this.availableInputDevices.audio.length === 0 ?  3000 : 500);
          
        }
      });    
      console.log('%c Communication Interface - InputDevices : ', 'color:white; background: #FF5722;', this.availableInputDevices);
    }

    
  };

  upsert = (array, item) => { // (1)
    const i = array.findIndex(_item => _item.id === item.id);
    if (i > -1) array[i] = item; // (2)
    else array.push(item);
  }

  setInputDevices = (audioId, videoId) => {
    try {      
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        console.log('***Setting devideIds in service here ****');
        return livechat.SetInputDevice(audioId, videoId);        
      }
    } catch (error) {
      
    }
  }

  registerCallbackEvents = () => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.OnOpenSuccess = (session: any) => {
          // assign the session id
          this.sessionId = session?.sid_tchat ?? '';
          this.callbacks.next({ callbackName: 'OpenSuccess', params: session }); // if no session found
        };
        livechat.OnOpenFailed = (retCode: string) => {
          this.callbacks.next({ callbackName: 'OpenFailed', params: retCode }); // if no session found
        };
        livechat.OnStartSuccess = (sid: string, tChatId: string, param: any) => {
          // assign the session id
          this.sessionId = tChatId;
          this.callbacks.next({ callbackName: 'StartSuccess', params: { sid, tChatId, param } }); // if new session start success
        };
        livechat.OnStartFailed = (code: any) => {
          this.callbacks.next({ callbackName: 'StartFailed', params: code }); // if new session start success
        };
        livechat.OnRemoteUserConnected = (name: string, agentId: string, sessionID: string, extraParam: any) => {
          this.callbacks.next({ callbackName: 'RemoteUserConnected', params: { name, agentId, sessionID, extraParam } });
        };
        livechat.OnConferenceUserLeft = (agent: string, reason: string) => {
          this.callbacks.next({ callbackName: 'ConferenceUserLeft', params: { agent, reason } });
        };
        livechat.OnCallQueued = (queuePos: number, queueType: string) => {
          this.callbacks.next({ callbackName: 'CallQueued', params: { queuePos, queueType } });
        };
        livechat.OnCallbackAutoRegistered = (reasonCode: string) => {
          this.callbacks.next({ callbackName: 'CallbackAutoRegistered', params: reasonCode });
        };
        livechat.OnTypingStateChanged = (agent: string, state: number) => {
          this.callbacks.next({ callbackName: 'TypingStateChanged', params: { agent, state } });
        };
        // received in livechat component
        livechat.OnAppMessageReceived = (agent: string, message: string, id: string) => {
          this.livechatCallback.next({ callbackName: 'AppMessageReceived', params: { agent, message, id } });
        };
        livechat.OnInternalServerError = (errorCode: string) => {
          this.callbacks.next({ callbackName: 'InternalServerError', params: errorCode });
        };
        // received in livechat component
        livechat.OnEcho = (message: string, id: string) => {
          this.livechatCallback.next({ callbackName: 'Echo', params: { message, id } });
        };
        livechat.OnServerStateChanged = () => {
          this.callbacks.next({ callbackName: 'ServerStateChanged', params: '' });
        };
        livechat.OnServersideEnd = (initiator: string, reason: string) => {
          this.callbacks.next({ callbackName: 'ServersideEnd', params: { initiator, reason } });
        };
        livechat.OnClientsideEnd = (initiator: string, reason: string) => {
          this.callbacks.next({ callbackName: 'ClientsideEnd', params: { initiator, reason } });
        };
        livechat.OnEnd = (initiator: string, reason: string) => {
          this.callbacks.next({ callbackName: 'End', params: { initiator, reason } });
        };
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }

      this.logToServer('info', 'CommunicationInterfaceService', 'registerCallbackEvents');
    } catch (error) {
      console.error('%c Communication Interface - registerCallbackEvents : ', 'color:white; background: #FF5722;', error);
    }
  };

  uploadFiles = (data: any) => {
    try {
      if(!this.appConfig.attachments || this.canUpload(data)) {
        if (this.appConfig.CommunicationInterface.livechat1.enabled) {
          livechat.uploadFiles(data);
        } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
        }
      } else {
        if(data && data[0]) {
          this.snackBar.open('OOPS! Maximum File Size limit exceeded, Please Upload a File below ' + this.getFileSizeLimitInMB(this.appConfig.attachments.maxSizeLimit),'', {duration : 5000});
          this.messengerService.handleProgressBar(false);
        }        
      }
      
    } catch (error) {
      console.error('%c Communication Interface - uploadFiles : ', 'color:white; background: #FF5722;', error);
    }
  };

  downloadUrl = (filename: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        const data = livechat.prepareDownloadURL(filename);
        return data;
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - downloadUrl : ', 'color:white; background: #FF5722;', error);
    }
  };

  uploadComplete = () => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.OnUploadComplete = (response: string) => {
          this.livechatCallback.next({ callbackName: 'UploadComplete', params: response });
        };
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - uploadComplete : ', 'color:white; background: #FF5722;', error);
    }
  };

  echoMessage = () => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.OnEcho = (message: any, id: any) => {
          this.callbacks.next({ callbackName: 'Echo', params: { message, id } });
        };
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - echoMessage : ', 'color:white; background: #FF5722;', error);
    }
  };

  setAVConfigs = (Config: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.SetAvConfigs(Config);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - setAVConfigs : ', 'color:white; background: #FF5722;', error);
    }
  };

  pauseAV = (audio: any, video: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.Pause(audio, video);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - pauseAV : ', 'color:white; background: #FF5722;', error);
    }
  };

  startAV = (startConfig: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.StartAvCall(startConfig.sid, startConfig.uid, startConfig.callType);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - startAV : ', 'color:white; background: #FF5722;', error);
    }
  };

  endAV = () => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.EndAvCall();
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - endAV : ', 'color:white; background: #FF5722;', error);
    }
  };

  startScreenshare = (startConfig: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.StartScreensharing(startConfig.sid, startConfig.uid);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - startScreenshare : ', 'color:white; background: #FF5722;', error);
    }
  };

  stopScreenshare = () => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.StopScreensharing();
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - startScreenshare : ', 'color:white; background: #FF5722;', error);
    }
  };

  notifyTypingChange = (state: any) => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
        livechat.NotifyTypingStateChange(state);
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - notifyTypingChange : ', 'color:white; background: #FF5722;', error);
    }
  };

  holdAV = () => {
    try {
      if (this.appConfig.CommunicationInterface.livechat1.enabled) {
      } else if (this.appConfig.CommunicationInterface.livechat2.enabled) {
      }
    } catch (error) {
      console.error('%c Communication Interface - holdAV : ', 'color:white; background: #FF5722;', error);
    }
  };

  noInternetConnection = () => {
    this.snackBar.open(`Network Connectivity Failed`, '', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar']
    });
    const navigationExtras: NavigationExtras = {
      queryParamsHandling: 'preserve',
      preserveFragment: true,
      state: { reload: true }
    };
    location.href = location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '?intent=' + this.intent;
    this.zone.run(() => { 
      this.route.navigate(['/'], navigationExtras);
    });
  };

  decryptAppConfig = () => {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  };

  logToServer = (type: string, unit: string, message: string) => {
    try {
      livechat.slog(type, `[VIVR.${unit}]`, `${this.sessionId ? `${this.sessionId}:` : ''} ${message}`);
    } catch (error) {}
  };

  triggerAudio(){
    if(this.appConfig.ChatQueueComponent.enableQueueAudio){
      this.audio.src = this.appConfig.ChatQueueComponent.queueAudio;
      this.audio.loop = true;
      this.audio.crossOrigin = 'anonymous';
      this.audio.volume = 0;
      // this.audio.play();
      let playPromise = this.audio.play();
      if (playPromise !== undefined) {
        playPromise.then(_ => {
          setTimeout(() => {
            this.audio.pause();
          }, 100);
        });
      }
      
    }
  }

  canUpload = (files) => {
    try{
      let can = true;
      files.forEach(file => {
          // check for configured file size
          if(file.size > this.appConfig.attachments.maxSizeLimit) {
            can = false;
          }
        // check for configured file type can be added here
      });
      return can;
    } catch(e) {
      console.log(e);
    }
    
  };

  getFileSizeLimitInMB = (sizeInBytes) => {
    return (sizeInBytes / (1024*1024)) + 'MB';
  }

  upgradeToVideo = () => {
    livechat.upgradeToVideo();
  }

  notifyEndOfSession = (initiator) => {
    this.endOfSession.next(initiator);
  }
}
